import React from 'react';
import skillsData from './About.json';
import './About.css';

const About = () => {
  return (
    <div className='about'>
      <h2 className='about-title'>About</h2>
      <div className='about-content'>
        <p>Hi, I'm Catherine.</p>
        <p>
          I like the technical challenges that come with building user-facing
          applications - component architecture, performance optimization, and
          making interfaces that actually work well.
        </p>
        <p>
          I'm currently contracting at Yahoo! Sports (brought back for a second
          engagement), building React + TypeScript components for millions of
          users. Before this I worked at Seekwell and Yandex, shipping features
          at scale.
        </p>
        <p>
          My approach is methodical: research thoroughly (AI is excellent for
          this), build iteratively, and refine until it's right. I work
          primarily with React and TypeScript, but I'm comfortable picking up
          whatever the stack requires.
        </p>
        <p>
          Currently seeking a full-time frontend or fullstack role where I can
          work with a strong team on meaningful projects. If that's you, reach
          out.
        </p>
      </div>
      <h2 className='about-title'>Skills</h2>
      {skillsData.skillsData.map((category, index) => (
        <div key={index} className='skill-category'>
          <h4 className='category-title'>{category.category}</h4>
          <div className='skills-list'>
            {category.skills.map((skill, idx) => (
              <div key={idx} className='skill-item'>
                <img
                  alt=''
                  src={require(`../../assets/${skill.image}`)}
                  className='skill-image'
                />
                {skill.name}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default About;
